import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import FlavorEditor from './FlavorEditor';
import './App.css';

function App() {
  const [names, setNames] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchNames = async () => {
      try {
        const response = await fetch('https://mixology.exmple.ru/api/names');
        if (!response.ok) throw new Error('Ошибка сети');
        const data = await response.json();
        setNames(data.sort((a, b) => a.id - b.id));
      } catch (error) {
        console.error('Ошибка:', error);
      }
    };

    fetchNames();
  }, []);

  const handleFlavorClick = (id) => {
    navigate(`/flavor/${id}`);
  };

  const getFlavorColor = (status) => ({
    empty: '#FFD700',
    complete: '#32CD32'
  }[status] || '#000');

  return (
    <div className="container">
      <h3 className="title">Всего вкусов: {names.length}</h3>
      <ul className="flavor-list">
        {names.map((item) => (
          <li
            key={item.id}
            className="flavor-item"
            onClick={() => handleFlavorClick(item.id)}
          >
            <span className="flavor-id">{item.id}</span>
            <span 
              className="flavor-name" 
              style={{ color: getFlavorColor(item.status) }}
            >
              {item.name}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}

function Root() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/flavor/:id" element={<FlavorEditor />} />
      </Routes>
    </Router>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);